import { AUTH_ERROR_MESSAGES } from "@/lib/errors";
import { AuthenticationError } from "apollo-server-errors";
import LogicaAPI from "./logicaapi";
class MySkp extends LogicaAPI {
  // MyスカパーIDでログイン
  login(mailAddress, password) {
    return this.post("/api/v1/users/myskyper_auth", {
      body: {
        mail_address: mailAddress,
        password
      }
    });
  }

  // マイページから連携するためのAPI
  // Myスカパー側のアカウント認証を行う
  authRelation(mailAddress, password) {
    if (this.isMaybeLoggedIn()) {
      return this.post("/api/v1/users/regist_myskyper_relation", {
        body: {
          mail_address: mailAddress,
          password
        }
      });
    } else {
      throw new AuthenticationError(AUTH_ERROR_MESSAGES["unauthorized"]);
    }
  }

  // 有料OTTのユーザーがvaluesにalice_bs_numbesを持っているときに
  // その情報をもとに連携する
  relation() {
    if (this.isMaybeLoggedIn()) {
      try {
        return this.get("/api/v1/users/regist_myskyper_relation");
      } catch (e) {
        console.log(e);
        return {
          result: false,
          my_transition_right_flag: false
        };
      }
    } else {
      throw new AuthenticationError(AUTH_ERROR_MESSAGES["unauthorized"]);
    }
  }

  // 放送契約割引情報を取得
  discountInfo(_ref) {
    let {
      productId,
      courseId
    } = _ref;
    if (this.isMaybeLoggedIn()) {
      return this.get("/api/v1/users/broadcast_discount", {
        product_id: productId,
        coutse_id: courseId
      });
    } else {
      throw new AuthenticationError(AUTH_ERROR_MESSAGES["unauthorized"]);
    }
  }
}
export default MySkp;